import { render, staticRenderFns } from "./ArticleComposition.vue?vue&type=template&id=2e2309ba"
import script from "./ArticleComposition.vue?vue&type=script&lang=ts"
export * from "./ArticleComposition.vue?vue&type=script&lang=ts"
import style0 from "./ArticleComposition.vue?vue&type=style&index=0&id=2e2309ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports